/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_TitleInputs */

const en_mcp_cap_library_title = /** @type {(inputs: Mcp_Cap_Library_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask what's ready`)
};

const es_mcp_cap_library_title = /** @type {(inputs: Mcp_Cap_Library_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pregunta qué está listo`)
};

/**
* | output |
* | --- |
* | "Ask what's ready" |
*
* @param {Mcp_Cap_Library_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_title = /** @type {((inputs?: Mcp_Cap_Library_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_title(inputs)
	return en_mcp_cap_library_title(inputs)
});